import { useMemo } from 'react';
import type { HypothesisCreativeEntry, HypothesisGroup, } from '../types/hypothesis';
import { orderByIds } from '../utils/orderByIds';
import { NO_HYPOTHESIS_KEY } from 'features/facebook';

export type UnpackedOrderByHypothesis = Record<string, string[]>;

interface UseOrderedHypothesisGroupsArgs {
  groups: HypothesisGroup[];
  noHypothesis: HypothesisCreativeEntry[];
  unpackedOrderByHypothesis: UnpackedOrderByHypothesis;
}

interface UseOrderedHypothesisGroupsResult {
  orderedGroups: HypothesisGroup[];
  orderedNoHypothesis: HypothesisCreativeEntry[];
}

const orderCreativesForHypothesis = (
  hypothesisKey: string,
  creatives: HypothesisCreativeEntry[],
  unpackedOrderByHypothesis: UnpackedOrderByHypothesis,
): HypothesisCreativeEntry[] =>
  orderByIds(creatives, unpackedOrderByHypothesis[hypothesisKey]);

const useOrderedHypothesisGroups = ({
  groups,
  noHypothesis,
  unpackedOrderByHypothesis,
}: UseOrderedHypothesisGroupsArgs): UseOrderedHypothesisGroupsResult =>
  useMemo(() => {
    const orderGroup = (group: HypothesisGroup): HypothesisGroup => ({
      ...group,
      creatives: orderCreativesForHypothesis(
        group.hypothesis,
        group.creatives,
        unpackedOrderByHypothesis,
      ),
    });

    return {
      orderedGroups: groups.map(orderGroup),
      orderedNoHypothesis: orderCreativesForHypothesis(
        NO_HYPOTHESIS_KEY,
        noHypothesis,
        unpackedOrderByHypothesis,
      ),
    };
  }, [groups, noHypothesis, unpackedOrderByHypothesis]);

export default useOrderedHypothesisGroups;
